import { useQuery } from '@tanstack/react-query';
import { BillingClient } from 'network/httpClients/BillingClient/BillingClient';
import { QUERY_KEYS } from 'network/queries/consts';
import { getQaBillingState } from 'test/fixtures/billing/quotaFixtures';
import { RECOMMENDATION_FIXTURES } from 'test/fixtures/billing/recommendationFixtures';
import { RecommendationResponse } from 'types/billing';

// Separate cache scope per source so a qa-state switch never serves a stale fixture.
const RECOMMENDATION_SCOPE = 'recommendation';
const REAL_SOURCE_KEY = 'real';

/**
 * GET /billing/v1/recommendation — usage-based plan recommendation (PLT-4059).
 * Freshness coupled to useQuota/useAccountInfo (D26); ?qa_billing_state mocks it.
 */
export const useRecommendation = () => {
  const qaState = getQaBillingState();

  return useQuery<RecommendationResponse>({
    queryKey: [
      QUERY_KEYS.BILLING_RECOMMENDATION,
      RECOMMENDATION_SCOPE,
      qaState ?? REAL_SOURCE_KEY,
    ],
    queryFn: async () => {
      if (qaState !== undefined) {
        return RECOMMENDATION_FIXTURES[qaState];
      }

      return await BillingClient.getRecommendation();
    },
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
};
